import React from "react";
import {
  REFUND_DAYS,
  getAccessBenefitLabel,
  getAccessSubtitle,
} from "../../config/subscription.js";
import "./offer2.css";

const formatBRL = (value) => {
  const number = parseFloat(value);
  return number % 1 === 0
    ? number.toFixed(0)
    : number.toFixed(2).replace(".", ",");
};

const Offer2 = ({ offer, handleSubmit }) => {
  const instalment12x = parseFloat(offer.prices.credit_card[12]);
  const totalCreditCard = instalment12x * 12;

  const pixPrice =
    parseFloat(
      offer.offer_type !== "DEFAULT"
        ? offer.prices.pix
        : offer.prices.base
    );

  const pixDiscount = Math.round(
    ((totalCreditCard - pixPrice) / totalCreditCard) * 100
  );

  const pixSavings = (totalCreditCard - pixPrice).toFixed(2);
  const accessSubtitle = getAccessSubtitle(offer.period);
  const accessBenefit = getAccessBenefitLabel(offer.period);

  return (
    <div className="auth-container-checkout">

      <div className="offer2">

        {/* Headline */}

        <h2 className="offer2-title">
          {offer.headline}
        </h2>

        <p className="offer2-subtitle">
          {accessSubtitle}
        </p>

        {/* Social Proof */}

        <div className="offer2-social">

          <div className="offer2-stars">
            ⭐⭐⭐⭐⭐
          </div>

          <div className="offer2-social-text">
            Mais de <strong>1.000 alunos</strong> no nosso site
          </div>

        </div>

        {/* Benefits */}

        <div className="offer2-benefits">

          <div className="offer2-benefit">
            ✔ Acesso completo a todos os cursos (mais de 100 horas de conteúdo didático)
          </div>

          <div className="offer2-benefit">
            ✔ Matérias de circuitos elétricos I, II e III (teoria, exercícios e experimentos)
          </div>

          <div className="offer2-benefit">
            ✔ Suporte tira-dúvidas com o Prof. Nicholas Yukio
          </div>

          <div className="offer2-benefit">
            ✔ {accessBenefit}
          </div>

          <div className="offer2-benefit">
            ✔ Certificados de conclusão
          </div>

        </div>

        {/* Price */}

        <div className="offer2-pricing">

          <div className="offer2-credit-title">
            Acesse por apenas
          </div>

          <div className="offer2-credit-price">

            12x de <span>R$ {formatBRL(instalment12x)}</span>

          </div>

          <div className="offer2-credit-note">
            no cartão de crédito
          </div>

          {offer.offer_type !== "DEFAULT" && (

            <div className="offer2-old-price">

              De R$ {formatBRL(offer.prices.base)}

            </div>

          )}

          <div className={pixDiscount > 0 ? "offer2-pix-box" : "offer2-pix-box-no-discount"}>

            <div className="offer2-pix-left">

              <div className="offer2-pix-price">

                ou R$ {formatBRL(offer.prices.pix)} à vista no Pix

              </div>

              {pixDiscount > 0 && (
                <div className="offer2-pix-save">
                  Economize R$ {pixSavings.replace(".", ",")}
                </div>
              )}

            </div>

{/*             {pixDiscount > 0 && (
              <div className="offer2-pix-badge">
                {pixDiscount}% OFF
              </div>
            )} */}

          </div>

        </div>

        {/* CTA */}

        <button
          className="offer2-button"
          onClick={handleSubmit}
        >
          Quero meu acesso agora
        </button>

        <div className="offer2-after-button">

          ✔ Liberação imediata após a confirmação do pagamento

        </div>

        {/* Guarantee */}

        <div className="offer2-guarantee">

          🔒 <strong>Garantia incondicional de {REFUND_DAYS} dias.</strong>

          <br />

          Se não gostar da plataforma, devolvemos 100% do seu dinheiro.

        </div>

        {/* Payment */}

        <div className="payment-icons">

          <img src="/pix.png" alt="Pix" />

          <img src="/visa.png" alt="Visa" />

          <img src="/mastercard.png" alt="Mastercard" />

          <img src="/elo.png" alt="Elo" />

        </div>

        {/* Trust */}

        <div className="offer2-trust">

          🔐 Ambiente seguro • Pagamento criptografado

        </div>

      </div>

    </div>
  );
};

export default Offer2;